export const trackPixelEvent = (eventName, parameters = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', eventName, parameters);
    }
};

export const trackPageView = () => {
    trackPixelEvent('PageView');
};

export const trackPurchase = (total, currency = 'BRL', products = []) => {
    trackPixelEvent('Purchase', {
        value: total,
        currency,
        num_items: products.length,
        content_type: 'product',
        content_ids: products.map(product => product.id?.toString() || product.product_id?.toString()),
        contents: products.map(product => ({
            id: product.id?.toString() || product.product_id?.toString(),
            quantity: product.quantity || product.product_quantity || 1,
            item_price: parseFloat(product.sale_price || product.price || 0)
        }))
    });
};

export const trackAddToCart = (product, quantity = 1, currency = 'BRL') => {
    trackPixelEvent('AddToCart', {
        content_ids: [product.id.toString()],
        content_type: 'product',
        value: parseFloat(product.sale_price) * quantity,
        currency,
        contents: [{
            id: product.id.toString(),
            quantity,
            item_price: parseFloat(product.sale_price)
        }]
    });
};

export const trackInitiateCheckout = (products = [], total, currency = 'BRL') => {
    trackPixelEvent('InitiateCheckout', {
        content_ids: products.map(product => product.id?.toString() || product.product_id?.toString()),
        content_type: 'product',
        value: total,
        currency,
        num_items: products.length,
        contents: products.map(product => ({
            id: product.id?.toString() || product.product_id?.toString(),
            quantity: product.quantity || product.product_quantity || 1,
            item_price: parseFloat(product.sale_price || product.price || 0)
        }))
    });
};

export const trackViewContent = (product, currency = 'BRL') => {
    trackPixelEvent('ViewContent', {
        content_ids: [product.id.toString()],
        content_type: 'product',
        value: parseFloat(product.sale_price),
        currency,
        contents: [{
            id: product.id.toString(),
            quantity: 1,
            item_price: parseFloat(product.sale_price)
        }]
    });
};

export const trackLead = () => {
    trackPixelEvent('Lead', {
        content_name: 'Customer Registration',
        value: 0,
        currency: 'BRL'
    });
};

export const trackSearch = (searchString) => {
    trackPixelEvent('Search', {
        search_string: searchString,
        content_type: 'product'
    });
};

export default {
    trackPixelEvent,
    trackPageView,
    trackPurchase,
    trackAddToCart,
    trackInitiateCheckout,
    trackViewContent,
    trackLead,
    trackSearch
};
